export const isMac = () => navigator.platform.toUpperCase().includes('MAC');
